import SakitForm from "./components/SakitForm";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function SakitFormPage() {
    const navigate = useNavigate();

    return (
        <div style={{ minHeight: "100vh", background: "#f8fafc", paddingBottom: 100 }}>

            {/* HEADER */}
            <div style={{ height: 70, display: "flex", alignItems: "center", padding: "0 16px" }}>
                <motion.button
                    onClick={() => navigate(-1)}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    whileTap={{ scale: 0.9 }}
                    style={{
                        width: 40, height: 40,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        background: "#fff", borderRadius: "50%",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        cursor: "pointer", border: "none",
                    }}
                    aria-label="Kembali"
                >
                    <ArrowLeft size={22} color="#333" />
                </motion.button>

                <h3 style={{ marginLeft: 12, fontSize: 18, fontWeight: 700 }}>
                    🤒 Form Pengajuan Izin Sakit
                </h3>
            </div>

            {/* CONTENT */}
            <div style={{ padding: "0 16px 10px 16px" }}>
                <SakitForm
                    isModalOpen={true}
                    onClose={() => navigate(-1)}
                />
            </div>

        </div>
    );
}
